var $769dcd2acc037e81$exports = {};
$769dcd2acc037e81$exports = {
    "info": `Informacije`,
    "negative": `Pogre\u{161}ka`,
    "positive": `Uspje\u{161}no`
};


export {$769dcd2acc037e81$exports as default};
//# sourceMappingURL=hr-HR.mjs.map
